<template>
    <div class="dropdown-selector clickable" :class="{open: open}">
        <div class="selected-item" @click="toggleOpen">
            <span>{{selected_item ? selected_item.label : placeholder}}</span>
            <i class="dropdown-chevron fas fa-chevron-down"></i>
        </div>
        <div class="options" v-if="open">
            <div v-for="option in other_options" :key="`option-${option.key}`" class="option" @click="select(option.key)">
                {{ option.label }}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        'options': {},
        'value': {},
        'placeholder' : {
            type: String,
            default: "None"
        }
    },

    data() {
        return {
            open: false,
        }
    },

    computed: {
        selected_item() {
            return this.options.find(option => option.key === this.value);
        },

        other_options() {
            return this.options.reduce((options, option )=> {
                if (option.key === this.selected_item?.key) options.push({key: null, label: this.placeholder});
                else options.push(option);
                return options;
            }, [])
        }
    },

    methods: {
        toggleOpen() {
            this.open = !this.open;
        },

        select(key) {
            this.$emit('input', key);
        },
    }
}
</script>
<style lang="sass" scoped>
    @import "../assets/colors.sass"

    .dropdown-selector
        position: relative
        height: 30px
        border: 1px solid $border-medium
        border-radius: 4px
        background-color: $darker-bg
        

        &:hover,&.open
            .dropdown-chevron
                background-color: black
    .selected-item
        display: flex
        align-items: center
        border-radius: 4px
        overflow: hidden
        height: 100%

        span
            flex: 1

        .dropdown-chevron
            padding: 8px 5px
            height: 100%
            width: 30px
            // display: inline-block

            
    .options
        width: calc(100% - 32px)
        position: absolute
        left: 2px
        top: 100%
        background-color: $darker-bg
        border: 1px solid $border-medium
        border-bottom-left-radius: 4px
        border-bottom-right-radius: 4px
    
    .option:hover
        background-color: black

    .option
        padding: 5px
        margin-bottom: 2px   
        
</style>